import { useState, useEffect } from "react";
import axios from "axios";

export default function Committee() {
  const [committees, setCommittees] = useState([]);
  const [activeCommittee, setActiveCommittee] = useState("");

  // Fetch committees from the API
  useEffect(() => {
    const fetchCommittees = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/committees`);
        setCommittees(response.data);
        if (response.data.length > 0) {
          setActiveCommittee(response.data[0].title); // Set the first committee as active
        }
      } catch (error) {
        console.error("Error fetching committees:", error);
      }
    };

    fetchCommittees();
  }, []);

  return (
    <div className="container mx-auto p-12 bg-gray-100 space-y-6 sm:space-y-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Governance/Committee</h1>
      </div>

      {/* Tab Navigation */}
      <div className="overflow-x-auto mb-4 ">
        <div className="flex space-x-4 ">
          {committees.map((committee) => (
            <button
              key={committee.title}
              onClick={() => setActiveCommittee(committee.title)}
              className={`py-2 px-4 rounded-lg text-lg font-semibold ${
                activeCommittee === committee.title
                  ? "bg-teal-500 text-white"
                  : "bg-transparent text-teal-500 hover:bg-teal-100"
              }`}
            >
              {committee.title}
            </button>
          ))}
        </div>
      </div>

      {/* Display Active Committee Members */}
      {committees.map(
        (committee) =>
          activeCommittee === committee.title && (
            <div key={committee.title} className="mt-6">
              <div className="bg-white p-4 rounded-lg shadow-md border-4 border-teal-500">
                <h2 className="text-teal-500 text-xl sm:text-2xl font-semibold">
                  {committee.title}
                </h2>
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full table-auto border-collapse">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-4 py-2 text-left">Name</th>
                        <th className="px-4 py-2 text-left">Department</th>
                        <th className="px-4 py-2 text-left">Designation</th>
                        <th className="px-4 py-2 text-left">Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {committee.members.map((member, index) => (
                        <tr key={index} className="border-b">
                          <td className="px-4 py-2">{member.name}</td>
                          <td className="px-4 py-2">{member.department}</td>
                          <td className="px-4 py-2">{member.designation}</td>
                          <td className="px-4 py-2">{member.number}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  );
}
